/** @jsxImportSource react */
import { Box, Typography } from '@mui/material'

/** The logo (public/logo.svg) and product name, as in the top bar and the signed-out pages. */
const BrandName = ({ variant = 'h6', size = 28, sx }) => (
  <Typography variant={variant} sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap', ...sx }}>
    <Box component="img" src="/logo.svg" alt="" sx={{ width: size, height: size, flexShrink: 0 }} />
    <span>Credintel <Box component="span" sx={{ color: 'primary.main' }}>CRM</Box></span>
  </Typography>
)

export default BrandName
